import { render } from "./ChatResponseFeedbackDialog.vue?vue&type=template&id=2fdbc683&scoped=true"
import script from "./ChatResponseFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./ChatResponseFeedbackDialog.vue?vue&type=script&lang=js"

import "./ChatResponseFeedbackDialog.vue?vue&type=style&index=0&id=2fdbc683&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdbc683"]])

export default __exports__